import { render, staticRenderFns } from "./Trivia.vue?vue&type=template&id=8374d776&scoped=true&"
import script from "./Trivia.vue?vue&type=script&lang=js&"
export * from "./Trivia.vue?vue&type=script&lang=js&"
import style0 from "./Trivia.vue?vue&type=style&index=0&id=8374d776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8374d776",
  null
  
)

export default component.exports